import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
//icons
import { BsSearch } from 'react-icons/bs';
//constant
import { choicesSearch } from 'constants';
//components
import CustomInput from 'components/backoffice/customInput';
import SearchTable from 'components/backoffice/table/SearchTable';
import { SelectInputCustom } from 'components/input';

const FiltersTableFaqs = ({
  formFilter,
  setFormFilter,
  handleClear,
  t,
  page,
  setPage
}) => {
  const handleSearch = (e, key) => {
    if (page > 1 && e !== '') setPage(1);
    setFormFilter((prevFormFilter) => ({ ...prevFormFilter, [key]: e }));
  };

  return (
    <SearchTable multipleInput={true} handleClear={handleClear}>
      <Form className="d-flex flex-column flex-lg-row justify-content-between form-filter-list gap-3">
        <SelectInputCustom
          choices={choicesSearch(t)}
          onCheckedItem={(e) => handleSearch(e, 'active')}
          value={formFilter.active}
        />
        <CustomInput
          handleKeyDown={true}
          type="text"
          value={formFilter.search}
          placeholder={t('searchbyquestion')}
          onChange={(e) => handleSearch(e, 'search')}
          icon={<BsSearch color="#161A25" className="icon-search" />}
        />
      </Form>
    </SearchTable>
  )
};

FiltersTableFaqs.propTypes = {
  formFilter: PropTypes.object,
  handleClear: PropTypes.func,
  setFormFilter: PropTypes.func,
  t: PropTypes.func,
  page: PropTypes.number,
  setPage: PropTypes.func
};


export default FiltersTableFaqs;
